import { ConfigProvider, ThemeConfig } from 'antd';
import { ThemeMode } from 'common/commonRedux/feature/themeSlice';
import { RootState } from 'common/redux/store';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { darkTheme } from './themes/dark';
import { lightTheme } from './themes/llight';

const themeMap: Record<ThemeMode, ThemeConfig> = {
  light: lightTheme,
  dark: darkTheme,
};
type AntdThemeConfigProviderType = { children: React.ReactNode };
const AntdThemeConfigProvider: React.FC<AntdThemeConfigProviderType> = ({
  children,
}) => {
  const themeMode = useSelector(
    (state: RootState) => state?.theme?.themeMode
  ) as ThemeMode;

  const theme = themeMap[themeMode || 'light'];

  useEffect(() => {
    const root = document.documentElement;
    if (themeMode === 'dark') {
      root.setAttribute('data-theme', 'dark');
    } else {
      root.removeAttribute('data-theme');
    }
  }, [themeMode]);

  const borderColor = themeMode === 'dark' ? '#2E3138' : '#E5E7EB';
  const StyledAppWrapper = styled.div`
    .ant-tabs-nav::before {
      border-bottom: none !important;
    }
    .ant-tabs-nav {
      border: 1px solid ${borderColor};
    }
    .ant-menu-item:hover {
      color: #1b73e8 !important;
    }
    .ant-menu-submenu-title:hover {
      color: #1b73e8 !important;
    }
    .ant-upload-wrapper.ant-upload-picture-card-wrapper {
      width: 100% !important;
    }
    .ant-upload.ant-upload-select {
      width: 100% !important;
      height: 172px !important;
    }
    .ant-upload-wrapper.ant-upload-picture-card-wrapper
      .ant-upload.ant-upload-select {
      width: 100% !important;
      height: 170px !important;
      background-color: transparent !important;
    }
  `;

  return (
    <ConfigProvider theme={theme}>
      <StyledAppWrapper>{children}</StyledAppWrapper>
    </ConfigProvider>
  );
};

export default AntdThemeConfigProvider;
